import React, { useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { RxHamburgerMenu } from 'react-icons/rx';
import { IoMdClose } from 'react-icons/io';
import { GoChevronDown } from 'react-icons/go';
import useOnClickOutside from '../useOnClickOutside';

const Navbar = () => {
  const [burgerBtn, setBurgerBtn] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const ref = useRef();
  const ref2 = useRef();
  useOnClickOutside(ref, dropDown, () => setDropDown(false));
  useOnClickOutside(ref2, burgerBtn, () => setBurgerBtn(false));

  return (
    <nav style={{ height: '60px' }}>
      <button type="button" className="d-md-none border-0 bg-transparent h4 ms-2 mt-1" onClick={() => setBurgerBtn((prev) => !prev)}>{burgerBtn ? <IoMdClose /> : <RxHamburgerMenu />}</button>
      <ul ref={ref2} className={`navBar d-md-flex ps-3 ${burgerBtn ? 'show-menu flex-column' : 'd-none'}`}>
        <li className="my-3 nav-item" key="1">
          <NavLink to="/" onClick={() => setBurgerBtn(false)}>Home</NavLink>
        </li>
        <li
          className="my-3 about nav-item"
          ref={ref}
          key="2"
          onClick={() => {
            setDropDown(((prev) => !prev));
          }}
          role="presentation"
        >
          About
          {' '}
          <GoChevronDown />
          {dropDown ? (
            <>
              <ul className="m-2 about-menu">
                <li className="p-2">
                  <NavLink to="/about/about-app" onClick={() => setBurgerBtn(false)}>About App</NavLink>
                </li>
                <li className="p-2">
                  <NavLink to="/about/about-author" onClick={() => setBurgerBtn(false)}>About Author</NavLink>
                </li>
              </ul>
            </>
          ) : ''}
        </li>
      </ul>
    </nav>
  );
};
export default Navbar;
